export default {
  breakpoints: ["40em", "52em", "64em", "80em", "90em"],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  colors: {
    primary: "#ffe200",
    red: "#ffe200",
    darkerRed: "#bd352f",
    redIntense: "#ffe200",
    blue: "#07c",
    lightgray: "#f6f6ff",
    bottom: "#05603e",
    bottomLight: "#0d9260",
    green: "#00f4c5",
    greenLight: "#c8fd03",
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256],
  fonts: {
    regular:
      "Inter, -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif",
    sans: "system-ui, sans-serif",
    mono: "Menlo, monospace",
  },
  shadows: {
    small: "0 0 4px rgba(0, 0, 0, .125)",
    large: "0 0 24px rgba(0, 0, 0, .125)",
  },
  posterW: {
    small: "100vw",
    large: "63.131313vh",
  },
};
